import React from 'react';
import {
  FaPhoneAlt,
  FaShieldAlt,
  FaHardHat,
  FaFirstAid,
  FaTrafficLight,
  FaFireExtinguisher,
  FaCheckCircle,
} from 'react-icons/fa';
import SecondaryButton from '../../../../Components/Buttons/SecondaryButton/SecondaryButton.component.jsx';
import PrimaryButton from '../../../../Components/Buttons/PrimaryButton/PrimaryButton.component.jsx';

import {
  HeroSection,
  HeroContainer,
  HeroContent,
  HeroCopy,
  HeroTitle,
  HeroDescription,
  ButtonGroup,
  OrderingNote,
  OrderingIcon,
  OrderingText,
  HeroVisual,
  VisualHeader,
  // VisualEyebrow,
  VisualTitle,
  VisualDescription,
  ProductIconDisplay,
  MainProductIcon,
  FloatingProductIcon,
  IconConnector,
  StatsGrid,
  StatCard,
  StatIcon,
  StatContent,
  StatValue,
  StatLabel,
} from './ProductsHero.styles';

const heroStats = [
  {
    value: '400,000+',
    label: 'Products available',
  },
  {
    value: '1,000+',
    label: 'Manufacturer brands',
  },
  {
    value: '6',
    label: 'Core safety categories',
  },
  {
    value: 'Direct',
    label: 'Personal ordering support',
  },
];

const ProductHero = () => {
  const handleContactClick = () => {
    window.location.href = '/contact-us';
  };

  const handleExploreClick = () => {
    window.location.href = '/explore-products';
  };

  return (
    <HeroSection>
      <HeroContainer>
        <HeroContent>
          <HeroCopy>
            <HeroTitle>
              The Right Equipment.
              <br />
              The Right Protection.
            </HeroTitle>

            <HeroDescription>
              Explore professional safety equipment and workplace essentials
              from trusted manufacturers. From PPE and first aid to traffic
              control and fire safety, our team helps you find the right
              products for your workplace.
            </HeroDescription>

            <ButtonGroup>
              <PrimaryButton
                functionName={handleContactClick}
                span="Contact Us to Order"
              />

              <SecondaryButton
                functionName={handleExploreClick}
                span="Explore Products"
              />
            </ButtonGroup>

            <OrderingNote>
              <OrderingIcon aria-hidden="true">
                <FaPhoneAlt />
              </OrderingIcon>

              <OrderingText>
                <strong>Order directly through our team.</strong>

                <span>
                  Product availability, pricing, quantities, and recommendations
                  are confirmed with you before every order is placed.
                </span>
              </OrderingText>
            </OrderingNote>
          </HeroCopy>

          <HeroVisual>
            <VisualHeader>
              {/* <VisualEyebrow>Workplace Safety</VisualEyebrow> */}

              <VisualTitle>Products. Guidance. Support.</VisualTitle>

              <VisualDescription>
                Tell us about your workplace and we&apos;ll help you find the
                right products for the job.
              </VisualDescription>
            </VisualHeader>

            <ProductIconDisplay aria-hidden="true">
              <IconConnector />

              <MainProductIcon>
                <FaShieldAlt />
              </MainProductIcon>

              <FloatingProductIcon $position="topLeft">
                <FaHardHat />
              </FloatingProductIcon>

              <FloatingProductIcon $position="topRight">
                <FaFirstAid />
              </FloatingProductIcon>

              <FloatingProductIcon $position="bottomLeft">
                <FaTrafficLight />
              </FloatingProductIcon>

              <FloatingProductIcon $position="bottomRight">
                <FaFireExtinguisher />
              </FloatingProductIcon>
            </ProductIconDisplay>

            <StatsGrid>
              {heroStats.map((stat) => (
                <StatCard key={stat.id}>
                  <StatIcon aria-hidden="true">
                    <FaCheckCircle />
                  </StatIcon>

                  <StatContent>
                    <StatValue>{stat.value}</StatValue>
                    <StatLabel>{stat.label}</StatLabel>
                  </StatContent>
                </StatCard>
              ))}
            </StatsGrid>
          </HeroVisual>
        </HeroContent>
      </HeroContainer>
    </HeroSection>
  );
};

export default ProductHero;
